/**
 * DS branch of the PL `FEATURE_SHOWCASE` widget. Renders the Panda `FeatureGridDS` block (Figma
 * `Widget-FeatureGrid`) — the same block the non-PL PDP feature section
 * (`image-with-text-product-details-section-ds`) uses. `FeatureGridDS` is a self-contained full-bleed
 * `<section>` (its own petal band, hero-media + cross-divider grid, responsive on its own), so unlike
 * the legacy `FeatureSectionTwo` branch it takes no `heading` and no `className`. The data→props
 * mapping is the shared `adaptFeatureShowcase` adapter; its output is already `FeatureGridDS`-shaped
 * (`{ imageProps, videoProps, contents }`).
 */

import { FeatureGridDS } from '@src/components/blocks/feature-grid-ds'
import { PLTypedWidgetProps } from '@src/components/pl-base-widget'
import {
  getFeatureSectionTwoAnalytics,
  useFeatureSectionTwoImpressionRef,
} from '@src/components/widgets/use-ia-impression'

import { adaptFeatureShowcase } from './feature-showcase.adapter'

import type { FeatureShowcaseWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

export function FeatureShowcaseDSWidget(props: PLTypedWidgetProps<FeatureShowcaseWidgetData>) {
  const data = props.data.featureShowcaseData
  // FS2 `feature_section_two_viewed` impression on scroll-into-view (IA-only), mirroring non-PL
  // `image-with-text-product-details-section-ds`. Hook is called unconditionally (Rules of Hooks); the
  // ref only wraps rendered output, so an empty section (null return below) never fires.
  const impressionRef = useFeatureSectionTwoImpressionRef(getFeatureSectionTwoAnalytics(data))
  if (!data?.media || data.items.length === 0) return null

  return (
    <div ref={impressionRef}>
      <FeatureGridDS {...adaptFeatureShowcase(data)} />
    </div>
  )
}
